<script>
import { Bar } from "vue-chartjs";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.defaults.global.defaultFontColor = "Black";
Chart.defaults.global.defaultFontFamily = "Roboto";

import api from "@/api/api";
import {logout} from "@/helpers";

export default {
  extends: Bar,
  plugins: [ChartDataLabels],
  props: {
    filtros_gerais: Object,
  },
  data: () => ({
    datalabelcolor: {
      '1. Excesso': "rgba(4, 35, 51, 0.9)",
      '2. Adequado': "rgba(0, 174, 81, 1)",
      '3. Exposto com pedido': "rgba(255, 254, 2, 1)",
      '4. Exposto sem pedido': "rgba(255, 191, 5, 1)",
      '5. Ruptura': "rgba(253, 0, 1, 1)",
      '6. Sem Movimento': "rgb(19,19,19)"
    },
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        mode: "point"
      },
      hover: {
        mode: "index"
      },
      scales: {
        xAxes: [
          {
            stacked: true
          }
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 10,
          bottom: 0
        }
      },
      legend: {
        position: "top",
        labels: {
          fontSize: 11,
          padding: 5,
        },
      },
      title: {
        display: true,
        text: "",
        position: "top"
      }
    }
  }),
  watch: {
    filtros_gerais: function () {
      this.buscarDadosGrafico();
    }
  },
  created() {
    this.buscarDadosGrafico();
  },
  methods: {
    buscarDadosGrafico() {
      api.post('indicadores/status-produto-v1/grafico', this.filtros_gerais)
        .then(response => {
          this.atualizarGrafico(response.data.status_produtos);
        })
        .catch(logout)
    },
    atualizarGrafico(dados_status_produto) {
      this.chartdata.labels = dados_status_produto.referencias;
      this.chartdata.datasets = [];

      Object.keys(dados_status_produto.grafico).reverse().forEach(chave => {
        this.chartdata.datasets.push({
          type: "bar",
          fill: false,
          label: chave,
          backgroundColor: this.datalabelcolor[chave],
          data: dados_status_produto.grafico[chave],
          datalabels: {
            display: false,
            anchor: "end",
            align: "end",
            rotation: -70
          }
        });
      });

      this.renderChart(this.chartdata, this.options);
    }
  }
};
</script>
